import { useEffect } from 'react'

import useIsServer from '../../hooks/useIsServer'

const useBucketListPageLayout = () => {
  const isServer = useIsServer()

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (!isServer) {
      const $footer: HTMLElement = document.querySelector('#site-footer')
      if ($footer) $footer.style.display = 'none'

      return () => {
        if ($footer) $footer.style.display = 'block'
      }
    }
  }, [])
}

export default useBucketListPageLayout
